import { IFormItem } from '../RegistrationFormTypes';
import { NameTypes } from '../../RegistrationEnums';
import { RegistrationFormItems } from '../RegistrationFormItems';
import { useRegistration } from '../../../../../Registration/containers/RegistrationDataStore';

type SignUpFormProps = {
	getFormItem: (
		item: IFormItem,
		substituteLabel?: JSX.Element,
		data?: any,
	) => void;
};

export default function SignUpForm({ getFormItem }: SignUpFormProps) {
	const registrationDataStore = useRegistration();
	const countriesByCountryId: object[] = [];
	for (let key in registrationDataStore.state.countries) {
		if (key?.length === 0 ?? false) {
			registrationDataStore.state.countries[' '] =
				registrationDataStore.state.countries[key];
			key = ' ';
		}

		countriesByCountryId.push({
			id: key,
			description: registrationDataStore.state.countries[key],
		});
	}

	return (
		<>
			{getFormItem(
				RegistrationFormItems.GetNameItem(NameTypes.FirstName),
			)}
			{getFormItem(RegistrationFormItems.GetNameItem(NameTypes.LastName))}
			{getFormItem(RegistrationFormItems.Email)}
			{getFormItem(RegistrationFormItems.Password)}
			{getFormItem(
				RegistrationFormItems.Country,
				undefined,
				countriesByCountryId,
			)}
			{getFormItem(RegistrationFormItems.KeepMeUpdated)}
		</>
	);
}
